export const ALL_ROLES = ['ADMIN', 'OWNER', 'USER', 'READER']
